import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../services/authContext';
import { GraduationCap, LogOut, User } from 'lucide-react';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const assetBase = process.env.PUBLIC_URL || '';

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-apple-bg">
      {/* Header */}
      <header className="sticky top-0 z-40 bg-apple-bg/80 backdrop-blur-xl border-b border-apple-border">
        <div className="max-w-[1800px] mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src={`${assetBase}/static/PolyU-Logo.png`} alt="PolyU" className="h-10 w-auto" />
            <span className="text-xl font-semibold text-apple-text">Data Science 101</span>
          </Link>

          <nav className="flex items-center gap-2">
            {isAuthenticated ? (
              <>
                <Link
                  to={user?.role === 'teacher' ? '/teacher' : '/courses'}
                  className="flex items-center gap-2 px-4 py-2 rounded-full text-apple-text hover:bg-apple-gray transition-colors"
                >
                  {user?.role === 'teacher' ? (
                    <>
                      <GraduationCap className="w-4 h-4" />
                      <span>Teacher Dashboard</span>
                    </>
                  ) : (
                    <>
                      <span>My Courses</span>
                    </>
                  )}
                </Link>
                
                <div className="flex items-center gap-3 ml-4 pl-4 border-l border-apple-border">
                  <div className="flex items-center gap-2 text-sm text-apple-text-secondary">
                    <div className="w-8 h-8 bg-apple-gray rounded-full flex items-center justify-center">
                      <User className="w-4 h-4" />
                    </div>
                    <span className="hidden sm:block">{user?.username}</span>
                  </div>
                  
                  <button
                    onClick={handleLogout}
                    className="p-2 rounded-full text-apple-text-secondary hover:bg-apple-gray hover:text-apple-text transition-colors"
                    title="Logout"
                  >
                    <LogOut className="w-4 h-4" />
                  </button>
                </div>
              </>
            ) : (
              <div className="flex items-center gap-3">
                <Link
                  to="/login"
                  className="btn-outline"
                >
                  Sign In
                </Link>
                <Link
                  to="/register"
                  className="btn-primary"
                >
                  Get Started
                </Link>
              </div>
            )}
          </nav>
        </div>
      </header>

      {/* Main Content */}
      <main className="min-h-[calc(100vh-64px)]">
        {children}
      </main>
    </div>
  );
}
